<template>
  <div class="navigation-link" v-if="$listeners.click || previousStep">
    <a href="#" @click.prevent="$emit('click')" v-if="$listeners.click">&larr; {{backLabel}}</a>
    <router-link :to="{name: previousStep}" v-else>&larr; {{backLabel}}</router-link>
  </div>
</template>
<script>

export default {
  computed: {
    currentStepIndex() {
      return this.steps.indexOf(this.$route.name);
    },
    previousStep() {
      if (this.currentStepIndex === 0) {
        return null;
      }
      return this.steps[this.currentStepIndex - 1];
    },
    steps() {
      return this.$store.getters.steps;
    },
    backLabel() {
      if (this.$route.params.pass && this.previousStep === 'pass') {
        return 'Change pass type';
      }
      return 'Back';
    },
  },
};
</script>
